<template>
  <div id="contenedor-main-contrato-gastos">
    <!-- ToolBar -->
    <tool-bar
      v-if="!soloLectura"
      v-on:nuevoGasto="nuevoGasto">
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <template v-if="getContratoGastos.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay gastos registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <listado
        v-if="!$apollo.loading"
        :solo-lectura="soloLectura"
        :listado="getContratoGastos">
      </listado>
    </template>
    <v-dialog
      v-model="mostrarRegistrarGasto"
      width="600"
      persistent>
      <registrar-gasto
        v-if="mostrarRegistrarGasto"
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrarVentana">
      </registrar-gasto>
    </v-dialog>
    <v-dialog
      v-model="mostrarEditarGasto"
      width="600"
      persistent>
      <editar-gasto
        v-if="esteGasto"
        :gasto-editar="esteGasto"
        v-on:cerrar="cerrarVentana">
      </editar-gasto>
    </v-dialog>
    <v-dialog
      v-if="esteGasto"
      v-model="mostrarEliminarGasto"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
        <eliminar-gasto
          :contratoGastoEliminar="esteGasto"
          v-on:cerrar="cerrarVentana">
        </eliminar-gasto>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_GASTOS from '@/graphql/querys/administracion/contratos/gastos/contratoGastos.gql';
import RegistrarGasto from '@/components/administracion/contratos/contrato/gastos/Nuevo.vue';
import EditarGasto from '@/components/administracion/contratos/contrato/gastos/Editar.vue';
import EliminarGasto from '@/components/administracion/contratos/contrato/gastos/Eliminar.vue';
import Listado from './listado/Main.vue';
import ToolBar from './ToolBar.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoGastos',
  components: {
    RegistrarGasto,
    EditarGasto,
    EliminarGasto,
    ToolBar,
    Listado,
  },
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mostrarRegistrarGasto: false,
      mostrarEditarGasto: false,
      mostrarEliminarGasto: false,
      esteGasto: null,
    };
  },
  mounted() {
    eventBus.$on('editar-contrato-gasto', (gasto) => {
      this.esteGasto = gasto;
      this.mostrarEditarGasto = true;
    });
    eventBus.$on('eliminar-contrato-gasto', (gasto) => {
      this.esteGasto = gasto;
      this.mostrarEliminarGasto = true;
    });
  },
  apollo: {
    contratoGastos: {
      query: CONTRATO_GASTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    nuevoGasto() {
      this.mostrarRegistrarGasto = true;
    },
    cerrarVentana() {
      this.esteGasto = null;
      this.mostrarRegistrarGasto = false;
      this.mostrarEditarGasto = false;
      this.mostrarEliminarGasto = false;
    },
  },
  computed: {
    getContratoGastos() {
      if (!this.contratoGastos) return [];
      return this.contratoGastos
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
